"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tour = exports.TooltipAnimation = void 0;
const Base_1 = require("./Base");
const Common_1 = require("./Common");
const index_1 = require("../index");
var TooltipAnimation;
(function (TooltipAnimation) {
    TooltipAnimation["FADE_IN"] = "fade-in";
    TooltipAnimation["SLIDE_IN_TOP"] = "slide-in-top";
    TooltipAnimation["SLIDE_IN_BOTTOM"] = "slide-in-bottom";
    TooltipAnimation["ZOOM_IN"] = "zoom-in";
})(TooltipAnimation || (exports.TooltipAnimation = TooltipAnimation = {}));
class Tour extends Base_1.Base {
    tour_name = '';
    steps = [];
    stepDuration = 0;
    showNavigationButtons = true;
    showNext = true;
    showPrevious = true;
    tooltipClass = '';
    customTooltipStyle = {};
    disableOnMobile = true;
    animationClass = TooltipAnimation.FADE_IN;
    _m = ['tour_name', 'date'];
    constructor(data, olMap) {
        super('tours', 18);
        (0, Common_1.setObjectProperties)(this, data, olMap, Tour);
    }
}
exports.Tour = Tour;
index_1.olm.tours = (ref, map) => {
    return new Tour(ref, map);
};
